import React from "react";
import { cn } from "@/lib/utils";

interface MainContentProps {
  children: React.ReactNode;
}

/**
 * MainContent component that holds the main application content
 */
export const MainContents: React.FC<MainContentProps> = ({ children }) => {
  return (
    <main
      className={cn(
        "flex-grow h-full overflow-auto flex flex-col",
        "transition-all duration-200 ease-in-out"
      )}
    >
      {children}
    </main>
  );
};
